import React from 'react';
import Category from '../Category/Category'
import PropTypes, { InferProps } from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { ESTIMATE_REQUIRED, HALF_HOURLY } from '../../modules/Screen/reducer';

export const categoryPropTypes = {
  name: PropTypes.string,
  categoryID: PropTypes.number,
  feeValue: PropTypes.number,
  feeType: PropTypes.string,
  feeQuantity: PropTypes.number,
  maxQuantity: PropTypes.number,
  helpText: PropTypes.string.isRequired,
  estimateRequired: PropTypes.bool,
  error: PropTypes.shape({
    isError: PropTypes.bool,
    message: PropTypes.string,
  }),
  isDisabled: PropTypes.bool,
}

const propTypes = {
  name: PropTypes.string,
  categories: PropTypes.arrayOf(
    PropTypes.shape(categoryPropTypes)
  ),
  isChecked: PropTypes.func,
  toggleCategory: PropTypes.func,
  setQuantity: PropTypes.func,
};

export default function SubStage(props: InferProps<typeof propTypes>): JSX.Element {
  const { name, categories, isChecked, toggleCategory, setQuantity } = props;

  return (
    <div className="substage">
      <Row>
        <Col md={4} className="substage-name">
          <h4>{name}</h4>
        </Col>
      </Row>
      {categories.map((obj, index) =>
        <Category
          name={obj.name}
          feeValue={obj.feeValue}
          feeQuantity={obj.feeQuantity}
          placeholder={obj.feeType === HALF_HOURLY ? "Number of half hours" : "Quantity"}
          units={obj.feeType === HALF_HOURLY ? "1/2 hour" : ""}
          estimateRequired={obj.feeType === ESTIMATE_REQUIRED}
          maxQuantity={obj.maxQuantity}
          helpText={obj.categoryHelpText}
          error={obj.error}
          isDisabled={obj.isDisabled}
          isChecked={() => isChecked(obj.categoryID)}
          handleClick={() => toggleCategory(obj.categoryID)}
          handleChange={(feeQuantity) => setQuantity(obj.categoryID, feeQuantity)}
          key={`substage-${obj.name}`}
        />
      )}
    </div>
  );
}
